import React from 'react'
import { Dialog, FlatButton } from 'material-ui'
import PropTypes from 'prop-types'

export default class MemberDataValidationDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool,
    error: PropTypes.string
  }

  render() {
    return (
      <Dialog
        actions={[
          <FlatButton label="OK" primary={true} key={'OK'}
            onTouchTap={() => this.props.onCloseRequest()} />
        ]}
        modal={false}
        open={this.props.open}
        contentStyle={{maxWidth: 300}}
        title={'Please, check the member info'}
        onRequestClose={() => this.props.onCloseRequest()}>
        {this.props.error}
      </Dialog>
    )
  }

}


// WEBPACK FOOTER //
// ./src/team/MemberDataValidationDialog.js